import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthService } from '../authentication/services/auth/auth.service';
import { Router } from '@angular/router';
import { MapConfig } from '../instant-analysis/models/map-config';
import { routerToMainService } from '../instant-analysis/services/routerToMainService';
import { TimestampTexts } from '../instant-analysis/models/timestamp-texts';
import { Tempo } from '../instant-analysis/models/tempo';
import { MatDialog } from '@angular/material/dialog';
import { DashboardToMapService } from '../dashboard/services/dashboard-to-map-service.service';
import { MapConfigService } from '../shared/services/map-config/map-config.service';
import { TimeFormatterService } from '../shared/util/time-formatter';

/**
 * Barra horizontal de menu com os links do sistema.
 */
@Component({
  selector: 'app-mainmenu',
  templateUrl: './mainmenu.component.html',
  styleUrls: ['./mainmenu.component.css']
})
export class MainmenuComponent implements OnInit {

  constructor(
    private authService: AuthService, 
    private router: Router, 
    private routerMessager : routerToMainService,
    public dialog: MatDialog,
    private routerReciever: DashboardToMapService,
    private mapConfigService: MapConfigService,
    private timeFormatterService: TimeFormatterService) { }
  
    navbar_link = "0"
  persistentMapDate : MapConfig;
  
  persistentMapDateText = ""
  buttonRT = "radio_button_unchecked"

  /**  */
  mapConfig: MapConfig;

  ngOnInit(): void {
    this.routerMessager.mapConfigChanged.subscribe(mapConfig => this.addPersistentDate(mapConfig))
    this.routerMessager.routerIdentity.subscribe(link => this.navbar_link=link)

    this.initMapConfig();
  }


  /**
   * Faz o logout do usuário (fecha a sessão no servidor e remove os dados do localStorage), e
   * navega para a página de login
   */
  logout() {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
  }

  /**
   * 
   * @param mapConfig 
   */
  addPersistentDate(mapConfig : any){
    this.persistentMapDate = mapConfig
  }

  /**
   * Formata um objeto Tempo como uma string 'DD/MM/YYYY hh:mm'
   * @param tempo objeto tempo
   * @returns string 'DD/MM/YYYY hh:mm'
   */
  formatText(tempo:Tempo){
    let date = new Date(tempo.ano, tempo.mes - 1, tempo.dia, tempo.hora, tempo.minuto);
    return this.timeFormatterService.format(date, '/', true);
  }

  /**
   * Obtém o texto da coluna selecionada
   * @returns texto da coluna selecionada
   */
  getTimestampText(){
    return TimestampTexts.texts[this.mapConfig?.geoData.selectedColumn];
  }

  /**
   * Navega para um link que está no menu.
   * @param link link a ser visitado.
   */
  changeLink(link:string){
    
    this.navbar_link = link;
    this.routerReciever.fowardedAnalise = undefined;
    this.router.navigateByUrl(link);
  }


  /**
   * Obtém a classe css que indica que a rota está ativa, na interface gráfica.
   * @param route rota
   * @returns routerLinkSelected, se a rota está ativa; routerLink, se estiver inativa.
   */
  getRouteCssClass(route: string): string {
    return route === this.router.url ? 'routerLinkSelected' : 'routerLink';
  }

  /** Inicializa referência a mapConfig de acordo com a url que o usuário está */
  private initMapConfig() {
    if (this.router.url == '/sistema/map') {
      this.mapConfig = this.mapConfigService.instantMapConfig;
    }
    else if (this.router.url == '/sistema/history') {
      this.mapConfig = this.mapConfigService.intervalMapConfig;
    }
    else {
      this.mapConfig = null;
    }
  }

  /**
   * Indica se pode exibir a parte das datas na barra de menu
   * @returns true se estiver na tela de análise instantânea ou histórica; false, caso contrário
   */
  private canShowDates() {
    return ['/sistema/map', '/sistema/history'].includes(this.router.url);
  }

}
